<template>
    <div>
      <homen></homen>
      <xuanfu class="pcshow"></xuanfu>
      <div class="container">
          <div class="wrap wrap1">
            <div class="content contentlogo">
              <img src="../assets/images/logowt.svg" alt="">
            </div>
            <img class="pcshow" src="../assets/images/bg_01.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/1.jpg" alt="">
            <div class="content content1">
                <h3>{{content.msg1}}</h3>
                <h3>{{content.msg2}}</h3>
                <p>THE 42<sup style="font-size:12px;">ND</sup> INTERNATIONAL CONGRESS ON ASSESSMENT CENTER METHODS</p>
                <p>{{content.msg4}}</p>
                <div class="btnbox">
                  <router-link to="./enroll_en">Registration</router-link>
                  <router-link to="./spon_en">Sponsorship</router-link>
                </div>
            </div>
            <div class="content content2">
              <h3>{{content.msg5}}</h3>
              <p>{{content.msg6}}</p>
            </div>
          </div>
           <div class="wrap">
            <img src="../assets/images/02_enbg.jpg" alt="" class="pcshow">
            <img src="../assets/images/02_menbg.jpg" alt="" class="mshow">
          </div>
          <div class="wrap wrap2">
            <img class="pcshow" src="../assets/images/bg_02.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/22.jpg" alt="">
            <div class="content content3">
              <p>{{content.msg7}}</p>
              <p>The 42<sup style="font-size:12px;">nd</sup> International Congress on Assessment Center Methods and Developing Leadership Talent will bring together in Shanghai world-renowned assessment center experts, as well as representatives of top companies and organizations that are using—and beneﬁting from—assessment centers and the rich data they provide to hire and develop—and retain—the next generation of leaders needed to drive transformation in an increasingly digital business environment. According to the 2018 Global Leadership Forecast, C-level executives identify developing the next generation of leaders as their number-one challenge—and assessment centers can help!  Assessment centers drive better decisions around spotting leadership potential, ﬁlling open leadership positions, building greater leadership capability, and providing customized development to individuals leaders.</p>
              <p>{{content.msg9}}</p>
            </div>
          </div>
          <div class="wrap wrap3">
            <img class="pcshow" src="../assets/images/enbg_03.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/m3en.png" alt="">
            <div class="content content4 pcshow">
                <h3>Meeting in China & Shanghai<span>BETTER LEADERS FOR A CHANGING BUSINESS WORLD!</span></h3>
            </div>
            <div class="content content5 pcshow">
              <h2>60+</h2>
              <h5>PRESENTERS AT THE 42ND</h5>
              <h5>INTERNATIONAL CONGRESS WILL COVER A</h5>
              <h5>WIDE RANGE OF TOPICS,INCLUDING:</h5>
              <p>{{content.msg10}}</p>
              <p>{{content.msg11}}</p>
              <p>{{content.msg12}}</p>
              <p>{{content.msg13}}</p>
              <p>{{content.msg14}}</p>
              <p>{{content.msg141}}</p>
              <p>{{content.msg142}}</p>
              <p>{{content.msg143}}</p>
              <p>{{content.msg144}}</p>
              <p>{{content.msg145}}</p>
            </div>
          </div>
          <div class="wrap wrap7">
            <img class="pcshow" src="../assets/images/bg_07.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/7.jpg" alt="">
            <div class="content content11">
              <div class="speakerboxs2">
                <h3>Speakers</h3>
                <p>（In No Particular Order）</p>
                <div class="swiper-container pcshow">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/bill.png" alt=""></a>
                                  <h6>William C. Byham, Ph.D.</h6>
                                  <p>Co-Founder and Executive Chairman, DDI</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/ytj.png" alt=""></a>
                                  <h6>Mindy Yeh</h6>
                                  <p>VP, DDI Asia</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/thonton.png" alt=""></a>
                                  <h6>George C. Thornton III, Ph.D.</h6>
                                  <p>Emeritus Professor, Colorado State University</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/lws.png" alt=""></a>
                                  <h6>Louis Liu</h6>
                                  <p>GM, Louis Development</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/sharif.png" alt=""></a>
                                  <h6>Sharif Khan</h6>
                                  <p>HR GM, Microsoft Asia</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/zk.png" alt=""></a>
                                  <h6>Kai Zhang, Ph.D.</h6>
                                  <p>Professor, School of Business, <br>Renmin University of China</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/lf.png" alt=""></a>
                                  <h6>Frank Li, Ph.D.</h6>
                                  <p>Independent Trainer/Consultant</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/gjd.png" alt=""></a>
                                  <h6>Jiandang Gu</h6>
                                  <p>Managing Director, Phoenix Contact China</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/hjh.png" alt=""></a>
                                  <h6>Jinghua He</h6>
                                  <p>VP, Tencent University</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/xuf.png" alt=""></a>
                                  <h6>Fang Xu</h6>
                                  <p>Executive Principal, TCL University</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/dwb.png" alt=""></a>
                                  <h6>Webb Ding</h6>
                                  <p>President of Fresenius Kabi China</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/mjh.png" alt=""></a>
                                  <h6>Jianhong Ma,Ph.D.</h6>
                                  <p>Professor, Department of Psychology<br> and Behavioral Science, Zhejiang University</p>
                              </li>
                          </ul>
                        </div>
                         <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/lzm.png" alt=""></a>
                                  <h6>Chaoming Liu,Ph.D.</h6>
                                  <p>Professor, Department of Psychology at<br> Fu Jen Catholic University</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/syh.png" alt=""></a>
                                  <h6>Yonghua Su,Ph.D.</h6>
                                  <p>Chairman and Chief Executive Officer,<br>NormStar Consulting</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/xxy.png" alt=""></a>
                                  <h6>Xiaoyong Xu,Ph.D.</h6>
                                  <p>Professor, School of Psychology,<br> Beijing Normal University</p>
                              </li>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/zwg.png" alt=""></a>
                                  <h6>Wilson Zhang</h6>
                                  <p>Senior Client Partner, Managing Director of<br> Korn Ferry China Advisory Business</p>
                              </li>
                          </ul>
                        </div>
                        <div class="swiper-slide">
                            <ul>
                              <li>
                                  <a href="javascript:;"><img src="http://static.hrflag.com/img/speakers/ddi/xxj.png" alt=""></a>
                                  <h6>Shirley Xu,Ph.D.</h6>
                                  <p>Associate Professor, School of Management, Fudan University</p>
                              </li>
                              <li class="toSpeakers">
                                  <router-link to="./speakers_en">More>></router-link>
                              </li>
                          </ul>
                        </div>
                    </div>
                    <!-- 如果需要分页器 -->
                    <div class="swiper-pagination"></div>
                    
                    <!-- 如果需要导航按钮 -->
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
                <ul class="mshow">
                    <li v-for="spe in spes" :key="spe.id">
                        <a href="javascript:;"><img :src="spe.speaker" alt=""></a>
                        <h6>{{spe.name}}</h6>
                        <p>{{spe.title}}</p>
                    </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="wrap wrap4">
            <img class="pcshow" src="../assets/images/enbg_04.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/m4en.png" alt="">
            <div class="content contentss pcshow">
              <h2>CHOOSE</h2>
              <h2>YOUR TRACK</h2>
            </div>
            <div class="contsbox pcshow">
                <div>
                  <p>Multiple learning tracks will be available, including assessment tracks, focusing on the design and delivery of assessment centers, and development tracks, devoted to building knowledge around high-payoﬀ development actions.</p>
                  <p>You can choose the track that’s right for you, to get the in-depth knowledge and best practices you need to be more informed and eﬀective in your role.</p>
                </div>
            </div>
          </div>
          <div class="wrap wrap5">
            <img class="pc1920" src="../assets/images/bg_05.jpg" alt="">
            <img class="pc1560" src="../assets/images/bg5_2.jpg" alt="">
            <img class="mshow" src="../assets/images/mimg/66.jpg" alt="">
            <div class="content content9 pcshow">
              <img src="../assets/images/logowt.svg" alt="">
              <div class="btnbox btnbox2">
                  <router-link to="./enroll_en">Registration</router-link>
                  <router-link to="./spon_en">Sponsorship</router-link>
              </div>
              <div class="ad">
                  <h3>{{content.msg5}}</h3>
                  <p>{{content.msg6}}</p>
              </div>
            </div>
            <div class="content content7">
                <h2 class="mshow">CHANCE</h2>
                <h4>AS THE 42<sup style="font-size:12px;">ND</sup> INTERNATIONAL CONGRESS</h4>
                <h5>{{content.msg16}}</h5>
                <h5>{{content.msg17}}</h5>
                <div class="more clear">
                  <ul>
                    <li>
                      <h6>▶&nbsp;&nbsp;AGENDA</h6>
                      <p>{{content.msg18}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;LEARN</h6>
                      <p>{{content.msg19}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;DISCOVER</h6>
                      <p>{{content.msg20}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;SEE</h6>
                      <p>{{content.msg21}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;BUILD</h6>
                      <p>{{content.msg22}}</p>
                    </li>
                   
                  </ul>
                  <ul>
                    <li>
                      <h6>▶&nbsp;&nbsp;NETWORK</h6>
                      <p>{{content.msg23}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;SEE</h6>
                      <p>{{content.msg24}}</p>
                    </li>
                    <li>
                      <h6>▶&nbsp;&nbsp;LEARN</h6>
                      <p>{{content.msg25}}</p>
                    </li>
                     <li>
                      <div>Note:Experience sessions delivered in both English and Chinese, through simultaneous translation.</div>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
      <foot></foot>
    </div>
</template>

<script>
import Swiper from 'swiper'
import xuanfu from '@/components/commn/xuanfu'
import homen from '@/components/commn/homen'
import foot from '@/components/commn/foot'
 export default {
      components:{
        xuanfu,
        homen,
        foot,
      },
       metaInfo: {
            title: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent; Leadership Development',
            meta: [
            {
                name: 'keywords',
                content: '42nd International Congress on Assessment Center Methods and Developing Leadership Talent;Talent Accessment; Leadership; Talent Development Forum; Leadership Development; Leader; Talent Analytics; Talent development practices'
            },
            {
                name: 'description',
                content: 'The 42nd International Congress on Assessment Center Methods and Developing Leadership Talent will bring together in Shanghai world-renowned assessment center experts, as well as representatives of top companies and organizations that are using—and beneﬁting from—assessment centers and the rich data they provide to hire and develop—and retain—the next generation of leaders needed to drive transformation in an increasingly digital business environment.'
            }
            ]
        },
  data () {
    return {
      content: {
        msg1: '',
        msg2: '',
        msg3: '',
        msg4: 'AND DEVELOPING LEADERSHIP TALENT',
        msg5: '11.13-15',
        msg6: 'SHANGHAI MARRIOTT HOTEL CITY CENTRE',
        msg7: 'With its origins in China, the assessment center is recognized today across business, education, and government as the most eﬀective and comprehensive way to gather the data needed to make highly accurate selection and development decisions. Now, in 2019, for the ﬁrst time China is hosting the preeminent conference on assessment centers.',
        msg8: '',
        msg9: '',
        msg10: '• Using assessment centers to identify leadership potential',
        msg11: '• How to use assessment data to identify development needs',
        msg12: '• How to combine assess and development in a digital environment',
        msg13: '• The impact of technology in assessment centers',
        msg14: '• Assessment center standards across the world',
        msg141: '• Methods of training HR professionals to use assessment data to make business decisions',
        msg142: '• Real-world assessment center and development applications',
        msg143: '• The proven eﬀectiveness of development actions based on assessment center research insights',
        msg144: '• New research on the validity of assessment centers',
        msg145: '• The latest online assessment tools, data analysis and successful application in talent development',
        msg15: '',
        msg16: 'REPRESENTS AN UNPRECEDENTED OP',
        msg17: 'PORTUNITY TO ...',
        msg18: 'Attend the preeminent conference on assessment centers and development without having to travel outside of China.',
        msg19: 'Learn how assessment centers can help your organization identify the next generation of leaders to drive transformation.',
        msg20: 'Discover how the combination of assessment center data and personalized development plans can help your organization retain more of its leadership talent.',
        msg21: 'See the latest innovations in the assessment center method, including how assessment center data is being used to make leader development more customized and eﬃcient.',
        msg22: 'Build your knowledge and learn best practices from global experts and practitioners from around the world, including those from China, Japan, Germany, South Africa, the United States, The Philippines, Indonesia, and Singapore.',
        msg23: 'Network with your colleagues from other business, education, and government organizations to learn more about assessment and development, and how they are being used together across a wide range of industries and applications.',
        msg24: 'See industry-leading thought leadership and solutions from DDI, a leading global leadership consulting ﬁrm and the pioneer in bringing the assessment center method to organization’s around the world.',
        msg25: 'Learn from conference content and presentations that will oﬀer a uniquely Chinese and Asian point of view on assessment and development—and how organizations like yours are beneﬁting by combining them.',
      },
      item1: [
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '01',msg2: '如何利用',msg3: '人才评鉴识别',msg4: '领导者潜力'},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''}
      ],
      item2: [
        {msg1: '02',msg2: '基于人才评鉴的',msg3: '研究洞见对',msg4: '发展行动的有效性'},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '04',msg2: '数字时代',msg3: '如何将评鉴',msg4: '与发展结合'},
        {msg1: '05',msg2: '技术对人才评鉴',msg3: '成本效益的',msg4: '积极影响'},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '09',msg2: '关于人才评鉴',msg3: '有效性的',msg4: '最新研究'}
      ],
      item3: [
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '03',msg2: '如何利用',msg3: '评鉴数据识别',msg4: '发展需求'},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '06',msg2: '全球人才',msg3: '评鉴的标准',msg4: ''},
        {msg1: '07',msg2: '人才评鉴和',msg3: '人才发展的',msg4: '现实应用'},
        {msg1: '08',msg2: '人力资源培训',msg3: '专家利用评鉴数据',msg4: '做出业务决策的方法'}
      ],
      item4: [
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '',msg2: '',msg3: '',msg4: ''},
        {msg1: '10',msg2: '最新线上测评工具',msg3: '数据分析及应用于',msg4: '人才发展成功实践'},
        {msg1: '',msg2: '',msg3: '',msg4: ''}
      ],
      spes:[
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/bill.png',
              name: 'William C. Byham, Ph.D.',
              title: 'Co-Founder and Executive Chairman, DDI'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/thonton.png',
              name: 'George C. Thornton III,Ph.D.',
              title: 'Emeritus Professor, Colorado State University'
          },
           {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/sharif.png',
              name: 'Sharif Khan',
              title: 'HR GM, Microsoft Asia'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/ytj.png',
              name: 'Mindy Yeh',
              title: 'VP, DDI Asia'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/lws.png',
              name: 'Louis Liu',
              title: 'GM, Louis Development'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/zk.png',
              name: 'Kai Zhang, Ph.D.',
              title: 'Professor, School of Business, Renmin University of China'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/lf.png',
              name: 'Frank Li, Ph.D.',
              title: 'Independent Trainer/Consultant'
          },
           {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/hjh.png',
              name: 'Jinghua He',
              title: 'VP, Tencent University'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/dwb.png',
              name: 'Webb Ding',
              title: 'President of Fresenius Kabi China'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/gjd.png',
              name: 'Jiandang Gu',
              title: 'Managing Director, Phoenix Contact China'
          },
           {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/xuf.png',
              name: 'Fang Xu',
              title: 'Executive Principal, TCL University'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/mjh.png',
              name: 'Jianhong Ma, Ph.D.',
              title: 'Professor, Department of Psychology and Behavioral Science, Zhejiang University'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/lzm.png',
              name: 'Chaoming Liu,Ph.D.',
              title: 'Professor, Department of Psychology at Fu Jen Catholic University'
          },
           {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/xxy.png',
              name: 'Xiaoyong Xu,Ph.D.',
              title: 'Professor, School of Psychology, Beijing Normal University'
          },
          {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/xxj.png',
              name: 'Shirley Xu,Ph.D.',
              title: 'Associate Professor, School of Management, Fudan University'
          },{
              speaker: 'http://static.hrflag.com/img/speakers/ddi/syh.png',
              name: 'Yonghua Su,Ph.D.',
              title: 'Chairman and Chief Executive Officer, NormStar Consulting'
          },
           {
              speaker: 'http://static.hrflag.com/img/speakers/ddi/zwg.png',
              name: 'Wilson Zhang',
              title: 'Senior Client Partner, Managing Director of Korn Ferry China Advisory Business'
          },
        ],
    }
  },
   mounted(){
     new Swiper ('.swiper-container', {
        slidesPerView: 3,
        slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
            disableOnInteraction: false, //手动滑动之后不打断播放
            delay: 3000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })        
  }
}
</script>

<style scoped>
  @import url('../assets/css/reset.css');
  @import url('../assets/css/index.css');
  .contentss {
    top: 5%;
    left: 0;
    width: 100%;
  }
  .contentss h2 {
    font-size: 4vw;
    color: #ffffff;
    text-align: center;
  }
  .wrap4 .contsbox {
    background: #f5af16;
    position: absolute;
    bottom: 0;
    color: #fff;
    width: 35%;
    left: 33%;
    height: 75%;
  }
  .contsbox div {
    padding: 30px;
  }
  .contsbox p {
    padding:0 30px;
    font-size: 1.4vw;
    line-height: 2;
  }
  .content3 p {
      font-size: 0.8vw;
  }
  .content5 {
    width: 40%;
    top: 27%;
    left: 50%;
    text-align: right;
}
  .content5 h5 {
    font-size: 1.2vw;
    margin: 0;
    line-height: 1.5;
    color: #ffffff;
  }
  .content5 p {
      font-size: 18px;
      line-height: 2.2vw;
      color: #ffffff;
  }
  .content7 {
    width: 40%;
    top: 15%;
    left: 54%;
    text-align: center;
}
  .content7 h5 {
      font-size: 2.0417vw;
      color: #ffffff;
  }
  .content7 h4 {
      font-size: 1.2vw;
      color: #ffffff;
  }
  .content7 h5 {
    font-size: 1.2vw;
    color: #ffffff;
  }
  .content7 .more {
    text-align: left;
    margin-top: 0;
}
.content7 .more li>div {
    font-size: 14px;
    padding: 5px 30px;
    background: #f5af16;
    margin-top: 0;
    font-weight: bold;
    color: #ffffff;
}

@media screen and (max-width:1620px){
  .wrap5 img.pc1920 {
    height: 1000px;
  }
  .wrap2 .pcshow {
    height: 750px;
  }
  .content3 p {
      font-size: 12px;
  }
  
}
@media screen and (max-width:1560px) {
  .content7 {
    width: 40%;
    top: 15%;
    left: 43%;
    text-align: center;
  }
}
@media screen and (max-width:1480px){
  .wrap5 img.pc1560 {
    height: 900px;
  }
  .content7 .more p {
    font-size: 12px;
  }
  .content7 {
    width: 50%;
    top: 15%;
    left: 39.5%;
    text-align: center;
  }
}
@media screen and (max-width: 1366px){
  .content5 p {
      font-size: 15px;
      line-height: 2;
  }
}
@media screen and (max-width:1200px) {
    .content5 p {
      font-size: 14px;
      line-height: 2;
      color: #ffffff;
  }
  .contentss h2 {
    font-size: 40px;
    color: #ffffff;
    text-align: center;
  }
  .contsbox p {
    padding: 0 30px;
    font-size: 15px;
    line-height: 2;
  }
}
  @media screen and (max-width:768px){
    .btnbox a {
      display: block;
      width: 80%;
      text-decoration: none;
      margin:0 auto;
      font-size: 16px;
    }
    .btnbox a:nth-child(1) {
        margin: 0 auto;
        padding: 12px 40px;
        border: none;
        background: -webkit-gradient(linear, left top, right top, from(#e4912b) , to(#db7729));
        background: linear-gradient(to right, #e4912b , #db7729);
        margin-bottom: 6%;
    }
    .wrap5 img.mshow {
        height: 1450px;
    }
    .content3 p {
        font-size: 3.5vw;
        padding: 0 50px;
        line-height: 2;
    }
    .content7 h4 {
        font-size: 3.5vw;
    }
    .content7 {
      width: 80%;
      top: 5%;
      left: 10%;
      text-align: center;
    }
    .speakerboxs2 ul li {
      text-align: center;
      margin: 10px;
      width: 100%;
      height: 180px;
    }
    .wrap7 img.mshow {
        height: 3400px;
    }
  }
  @media screen and (max-width:480px){
     .wrap2 img.mshow {
        height: 1150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/english.vue